import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import api from "../../api/Api.js";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const AddCategoryPage = () => {

  // =========================
  // NAVIGATE
  // =========================

  const navigate = useNavigate();

  // =========================
  // STATE
  // =========================

  const [categoryRows, setCategoryRows] = useState([
    {
      categoryName: "",
      slug: ""
    }
  ]);

  const [addedBy, setaddedBy] = useState("");

  // =========================
  // ADD ROW
  // =========================

  const addCategoryRow = () => {

    setCategoryRows([
      ...categoryRows,
      {
        categoryName: "",
        slug: ""
      }
    ]);

  };

  // =========================
  // REMOVE ROW
  // =========================

  const removeCategoryRow = async (index) => {

    if (categoryRows.length === 1) {
      toast.error("At least one row required");
      return;
    }

    const confirm = await Swal.fire({
      title: "Delete Row?",
      icon: "warning",
      showCancelButton: true
    });

    if (!confirm.isConfirmed) return;

    const updated = categoryRows.filter(
      (_, i) => i !== index
    );

    setCategoryRows(updated);

  };

  // =========================
  // HANDLE INPUT CHANGE
  // =========================

  const handleCategoryChange = (
    index,
    field,
    value
  ) => {

    const updatedRows = [...categoryRows];

    updatedRows[index][field] = value;

    // AUTO GENERATE SLUG
    if (field === "categoryName") {

      updatedRows[index].slug = value
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-");

    }

    setCategoryRows(updatedRows);

  };

  // =========================
  // SAVE CATEGORY
  // =========================

  const saveCategory = async () => {

    const hasEmpty = categoryRows.some(
      (row) => !row.categoryName
    );

    if (hasEmpty) {
      toast.error("Category Name is required");
      return;
    }

    const confirm = await Swal.fire({
      title: "Save Category?",
      text: "Do you want to save this Category?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes Save"
    });

    if (!confirm.isConfirmed) return;

    try {

      const payload = {
      
        categories: categoryRows
      };

      // API
      const res = await api.post(
        "/adminBlog/saveCategory",
        payload
      );

      // SUCCESS
      if (res.data.success) {

        Swal.fire(
          "Success",
          "Category Saved Successfully",
          "success"
        );

        // RESET
        setCategoryRows([
          {
            categoryName: "",
            slug: ""
          }
        ]);

        // NAVIGATE
        navigate("/category/manage-category");

      } else {

        Swal.fire(
          "Error",
          res.data.message,
          "error"
        );

      }

    } catch (error) {

      // console.log(error);
  // console.log("FULL ERROR =>", error);
  // console.log("RESPONSE DATA =>", error?.response?.data);

  toast.error(error?.response?.data?.message || "Server Error");
      toast.error("Server Error");

    }

  };

  // =========================
  // JSX
  // =========================

  return (

    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}

      <div className="card shadow-sm border-0 mb-4 bg-primary-subtle rounded-3">

        <div className="card-body d-flex justify-content-between align-items-center">

          <h4 className="fw-bold mb-0">
            Add Category
          </h4>

          <Link
            to="/category/manage-category"
            className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
          >
            <ArrowLeft size={16} />
            Back
          </Link>

        </div>

      </div>

      <div className="row">

        {/* TABLE */}

        <div className="col-lg-12">

          <div className="card shadow-sm border-0">

            <div className="card-body">

              <table className="table table-hover table-bordered align-middle mb-0">

                <thead className="table-light">

                  <tr>

                    <th width="50">
                      Sl.No
                    </th>

                    <th>
                      Category Name
                    </th>

                    <th>
                      Slug
                    </th>

                    <th width="120">
                      Action
                    </th>

                  </tr>

                </thead>

                <tbody>

                  {categoryRows.map(
                    (row, index) => (

                      <tr key={index}>

                        <td>
                          {index + 1}
                        </td>

                        {/* CATEGORY NAME */}

                        <td>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Category Name"
                            value={row.categoryName}
                            onChange={(e) =>
                              handleCategoryChange(
                                index,
                                "categoryName",
                                e.target.value
                              )
                            }
                          />

                        </td>

                        {/* SLUG */}

                        <td>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Slug"
                            value={row.slug}
                            onChange={(e) =>
                              handleCategoryChange(
                                index,
                                "slug",
                                e.target.value
                              )
                            }
                          />

                        </td>

                        {/* ACTION */}

                        <td>

                          <button
                            type="button"
                            className="btn btn-success btn-sm me-2"
                            onClick={addCategoryRow}
                          >
                            <i className="fa fa-plus-square"></i>
                          </button>

                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() =>
                              removeCategoryRow(index)
                            }
                          >
                            <i className="fa fa-trash"></i>
                          </button>

                        </td>

                      </tr>

                    )
                  )}

                </tbody>

              </table>

            </div>

          </div>

        </div>

        {/* SAVE BUTTON */}

        <div className="col-lg-12 text-center">

          <button
            className="btn btn-info text-white px-5 mt-3"
            onClick={saveCategory}
          >
            Save Category
          </button>

        </div>

      </div>

    </div>

  );

};

export default AddCategoryPage;